import { render, staticRenderFns } from "./tel-input.vue?vue&type=template&id=d97b67ca&"
import script from "./tel-input.vue?vue&type=script&lang=js&"
export * from "./tel-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports